import React, { PureComponent } from 'react';

import { Button, ButtonIcon } from 'components/button';
import { I18n } from 'components/translate';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

import SubtitleActions from '../../SubtitleActions';

export default class SubtitleUploadTranscribe extends PureComponent {
  static propTypes = {
    mediaId: PropTypes.string,
    onUpload: PropTypes.func
  };

  render() {
    return (
      <div className="subtitle__upload__transcribe">
        <Button
          size="small"
          outline
          type="button"
          className="mb__md _text-wrap"
          onClick={this.handleTranscribe}
        >
          <I18n label="player_subtitles.transcribe.cta_new" />
        </Button>

        <ButtonIcon
          className="subtitle__section__upload"
          icon="upload"
          transparent
          onClick={this.upload}
        >
          <I18n label="player_subtitles.upload.cta_new" />
        </ButtonIcon>
      </div>
    );
  }

  transcribe = () => {
    const { mediaId } = this.props;

    SubtitleActions.transcribeMedia(mediaId);
  };

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  handleTranscribe = debounce(this.transcribe, 300);

  upload = () => {
    this.props.onUpload && this.props.onUpload();
  };
}
